module.exports = __webpack_public_path__ + "static/img/2.4722e17.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/2.png
// module id = 8CjT
// module chunks = 0